import CreateOrderPage from "./createOrderPage";
export default CreateOrderPage;
